export const check = {
  companyId: "",
  masterId: 0,
  enable: false,
  xWebId: "",
  apiKey: "",
  merchantId: "",
  webToken: "",
  terminalId: "",
  authKey: "",
  termsAndConditions: "",
  staxEnable: false,
  paymentGateway: "",
};

export interface OpenEdgePaymentData {
  companyId: string | null;
  masterId: number | null;
  enable: boolean;
  authKey: string | null;
}

export const objError = {
  merchantId: {
    status: false,
    message: "",
  },
};

export interface ErrorProps {
  status: boolean;
  message: string;
}

export interface CybersourcePaymentDataErrorProps {
  merchantId: ErrorProps;
}

export const WEB_TOKEN_ID = "webToken";
export const MERCHANT_ID = "merchantId";
export const API_KEY = "apiKey";
export const WEB_TOKEN_ID_MANDATORY = "Web Token is mandatory";
export const MERCHANT_ID_MANDATORY = "Merchant ID is mandatory";
export const API_KEY_MANDATORY = "Api Key is mandatory";
export const DETAILS_INVALID = "Details do not match, try again";
export const STAX = "STAX";
export const CYBERSOURCE = "CYBERSOURCE";
export const STAX_TITLE = "Successware Payment";
export const CYBERSOURCE_TITLE = "Cybersource Payment";
export const STAX_ENABLED_MESSAGE =
  "Successware Payment option has been successfully enabled";
export const STAX_DISABLED_MESSAGE =
  "Successware Payment option has been successfully disabled";
export const CYBERSOURCE_ENABLED_MESSAGE =
  "Cybersource Payment option has been successfully enabled";
export const CYBERSOURCE_DISABLED_MESSAGE =
  "Cybersource Payment option has been successfully disabled";
